import React from "react"
import ChartMessagesSentPerDay from "../ChartMessagesSentPerDay"
import ChartWorstSensorsAlerts from "../ChartWorstSensorsAlerts"
import axios from "axios";
import {searchAlerts} from "../TimelineSideAlerts";

const CancelToken = axios.CancelToken;
var cancel;

export function searchData(company, year, month, token) {
    cancel && cancel()

    return axios.get('/api/v2/alerts/dados_alertas/' + company + '/' + year + '/' + month,
        {
            headers: {
                "Authorization": token
            },
            cancelToken: new CancelToken(
                function executor(c) {
                    cancel = c;
                }
            )
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

class ChartAlertsContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            sensorAlertsData: [],
            noSensorAlertsData: false,
            messagesSentPerDayData: [],
            noMessagesSentPerDayData: false
        };

    };

    requestData = () => {

        this.setState({
            isLoading: true,
            sensorAlertsData: [],
            messagesSentPerDayData: [],
            noSensorAlertsData: false,
            noMessagesSentPerDayData: false
        });

        searchData(this.props.company, this.props.year, this.props.month, this.props.token)
            .then(response => {
                this.setState({
                    isLoading: false,
                    sensorAlertsData: response.data.sensores,
                    noSensorAlertsData: !response.data.sensores.length,
                    messagesSentPerDayData: response.data.dias,
                    noMessagesSentPerDayData: !response.data.dias.length
                });
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    console.log(error);
                    this.setState({isLoading: false});
                }
            });

    }

    componentDidMount() {
        this.requestData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.month !== prevProps.month) {
            this.requestData();
        }
    }

    render() {
        return (
            <div className="left col s12 m8">
                <ChartMessagesSentPerDay data={this.state.messagesSentPerDayData} isLoading={this.state.isLoading} noData={this.state.noMessagesSentPerDayData} />
                <ChartWorstSensorsAlerts data={this.state.sensorAlertsData} isLoading={this.state.isLoading} noData={this.state.noSensorAlertsData} />
            </div>
        );
    }
}

export default ChartAlertsContainer
